import CustomerReferralShare from '@sectionsJS/customer-referral/share.js';

document.addEventListener('DOMContentLoaded', () => {
  new CustomerReferralShare();
});
